import React from 'react';
import Timetable from "./Timetable";

function ExcursionTimetable(props) {
    return (
        <Timetable {...props} useExcursionLabels={true} />
    );
}

export default ExcursionTimetable;